/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { GeneralCode } from "../../../../../../../../../../constant/GeneralCode"
import { SchedulesExportFRM103ResType } from "../../../../../../../models/list/export"

const { OTHER } = GeneralCode

export const groupByTravelerId = (
  dataSource: SchedulesExportFRM103ResType[],
): SchedulesExportFRM103ResType[] => {
  const newDataSource = new Map<string, SchedulesExportFRM103ResType>()

  dataSource.forEach(({ details, info, lodgings, stays }) => {
    const { travelerId } = info

    if (!newDataSource.has(travelerId)) {
      newDataSource.set(travelerId, {
        details: [...details],
        info: info,
        lodgings: [...lodgings],
        stays: [...stays],
      })
    } else {
      const existing = newDataSource.get(travelerId)!
      existing.details.push(...details)
      existing.info = info
      existing.lodgings.push(...lodgings)
      existing.stays.push(...stays)
    }
  })

  return Array.from(newDataSource.values()).map(
    ({ details, info, lodgings, stays }) => {
      const othersRemarks1: string[] = []

      return {
        details: details
          .map((itemDetail) => {
            othersRemarks1.push(itemDetail.othersRemarks1)

            return {
              ...itemDetail,
              arrivalCityName:
                itemDetail.arrivalCityCode === OTHER
                  ? itemDetail.arrivalCityNameOther
                  : itemDetail.arrivalCityName,
              departureCityName:
                itemDetail.departureCityCode === OTHER
                  ? itemDetail.departureCityNameOther
                  : itemDetail.departureCityName,
            }
          })
          .sort(
            (a, b) =>
              new Date(a.departureDateTime).getTime() -
              new Date(b.departureDateTime).getTime(),
          ),
        info: {
          ...info,
          othersRemarks1: othersRemarks1.join("|"),
        },
        lodgings: lodgings.sort((a, b) =>
          a.travelLodgingId.localeCompare(b.travelLodgingId),
        ),
        stays: stays.sort((a, b) =>
          a.travelStayId.localeCompare(b.travelStayId),
        ),
      }
    },
  )
}
